import { Map, List, fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';

import * as attachLib from 'libs/attachLib';
import * as normal from 'libs/normalizer';

// action types
const INITIAL_STORE = 'templateAttach/INITIAL_STORE';
const CHANGE_PARAM = 'templateAttach/CHANGE_PARAM';
const RELOAD_ATTACH = 'templateAttach/RELOAD_ATTACH';
const GET_TEMPLATEATTACH = 'templateAttach/GET_TEMPLATEATTACH';
const ADD_TEMPLATEATTACH = 'templateAttach/ADD_TEMPLATEATTACH';
const COPY_TEMPLATEATTACH = 'templateAttach/COPY_TEMPLATEATTACH';
const UPDATE_TEMPLATEATTACH = 'templateAttach/UPDATE_TEMPLATEATTACH';
const DELETE_TEMPLATEATTACH = 'templateAttach/DELETE_TEMPLATEATTACH';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeParam = createAction(CHANGE_PARAM);
export const reloadAttach = createAction(RELOAD_ATTACH);
export const getAttach = createAction(GET_TEMPLATEATTACH, attachLib.getAttach);
export const addAttach = createAction(ADD_TEMPLATEATTACH, attachLib.addAttach);
export const copyAttach = createAction(COPY_TEMPLATEATTACH, attachLib.copyAttach);
export const updateAttach = createAction(UPDATE_TEMPLATEATTACH, attachLib.updateAttach);
export const deleteAttach = createAction(DELETE_TEMPLATEATTACH, attachLib.deleteAttach);

// initial state
const initialState = fromJS({
  data: {
    result: -1,
    success: [],
    fail: []
  },
  listIndexByNo: {},
  needReload: false,
  file: null,
  param: Map({
    filter: Map({}),
    sort: [{ field: 'leakFileNo', order: 'DESC' }]
  }),
  totalPages: 0,
  totalCount: 0
});

// reducer
export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    [RELOAD_ATTACH]: (state, action) => {
      return state.set('needReload', true);
    },
    ...pender({
      type: GET_TEMPLATEATTACH,
      onSuccess: (state, action) => {
        const { data } = action.payload;
        const { offset, limit } = action.payload.config.params;

        // 전체 목록 수
        const totalCount = data.list.length > 0 ? data.list[0].rnum + offset : 0;
        // 전체 페이지 수
        const totalPages = Math.ceil(totalCount / limit);

        const stateObj = normal.payloadDataSaver(state, 'data', data);
        return stateObj
          .set('needReload', false)
          .set('totalPages', totalPages)
          .set('totalCount', totalCount)
          .set('listIndexByNo', fromJS(normal.listIndexByNo(data.list, 'attachInfoNo')));
      },
      onFailure: (state, action) => {
        console.log('GET_TEMPLATEATTACH 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: ADD_TEMPLATEATTACH,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('ADD_TEMPLATEATTACH 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    }),
    ...pender({
      type: UPDATE_TEMPLATEATTACH,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('UPDATE_TEMPLATEATTACH 실패');
      }
    }),
    ...pender({
      type: DELETE_TEMPLATEATTACH,
      onSuccess: (state, action) => {
        return state.set('needReload', true);
      },
      onFailure: (state, action) => {
        console.log('DELETE_TEMPLATEATTACH 실패');

        // 401 등 실패에 대한 적절한 처리 필요함
        //return state; //state.set('data', initialState.get('data'));
      }
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/templateAttach.js